var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPagePortfolio(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,49V1H8v5H6v2h2v4H6v2h2v4H6v2h2v4H6v2h2v4H6v2h2v4H6v2h2v4H6v2h2v5H44z M10,38h2v-2h-2v-4h2v-2h-2v-4h2v-2h-2v-4h2v-2   h-2v-4h2v-2h-2V8h2V6h-2V3h32v44H10v-3h2v-2h-2V38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,8H17v14h20V8z M35,20H19V10h16V20z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 14,
    x: 20,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 14,
    x: 20,
    y: 31
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagePortfolio);
export default __webpack_public_path__ + "static/media/page_portfolio.64eb42e345cb648cf3b80116359d452b.svg";
export { ForwardRef as ReactComponent };